var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diolog-head"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{class:_vm.icon +' head-icon',on:{"click":function($event){return _vm.$emit('on-close')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }